import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { normalizeLang } from "../i18n";

/**
 * קישורים ל־/legal/privacy ו־/legal/terms — שומרים ?lang= מה-URL הנוכחי
 */
export default function LegalFooterLinks({ className = "" }) {
  const location = useLocation();
  const { qs, lang } = useMemo(() => {
    const langNorm = normalizeLang(
      new URLSearchParams(location.search).get("lang") ||
        (typeof window !== "undefined" ? window.localStorage.getItem("innervoice_lang") : "he")
    );
    const q = new URLSearchParams(location.search);
    q.set("lang", langNorm);
    return { qs: q.toString(), lang: langNorm };
  }, [location.search]);

  const labels =
    lang === "he"
      ? { p: "מדיניות פרטיות", t: "תנאי שימוש" }
      : lang === "es"
        ? { p: "Privacidad", t: "Terminos" }
        : { p: "Privacy", t: "Terms" };

  return (
    <div className={`legal-footer-links ${className}`.trim()} role="navigation" aria-label="Legal">
      <Link to={`/legal/privacy?${qs}`} className="legal-footer-link">
        {labels.p}
      </Link>
      <span className="legal-footer-sep" aria-hidden>
        ·
      </span>
      <Link to={`/legal/terms?${qs}`} className="legal-footer-link">
        {labels.t}
      </Link>
    </div>
  );
}
